import { Ajax, useAction } from 'utils';

export const useSignUpAction = () =>
  useAction(({ orgId, eventSubscriptionSignUpStr }) => Ajax.post(
    `/nixle/eventSubscription/${orgId}/signUp`,
    new URLSearchParams(`eventSubscriptionSignUpStr=${eventSubscriptionSignUpStr}`).toString()
  ));
